export default __webpack_public_path__ + "static/media/Snakes Prey.9a138798.png";